import React from 'react';
import { GoogleMap, InfoWindow, Marker,  useJsApiLoader } from '@react-google-maps/api';


/**
 * Map
 * 
 */
const TribalismGoogleMap = () => {
  // Is map loaded
  const {isLoaded} = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: process.env.NEXT_PUBLIC_GOOGLE_MAP_API_KEY
  });
  // Info Window visibility
  const [showInfo, setShowInfo] = React.useState(false);
  // Old Office coordinate
  //const center = {lat: -37.81984810694671, lng: 144.95695645268466};
  // New Office coordinate
  const center = {lat: -37.817770, lng: 144.955400};
  // Map Options
  const options = {
    zoom: 14,
    center: center,
    scrollwheel: false,
    zoomControl: true,
    styles: [
      {
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#242f3e"
          }
        ]
      },
      {
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#746855"
          }
        ]
      },
      {
        "elementType": "labels.text.stroke",
        "stylers": [
          {
            "color": "#242f3e"
          }
        ]
      },
      {
        "featureType": "administrative.locality",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#d59563"
          }
        ]
      },
      {
        "featureType": "poi",
        "elementType": "labels.icon",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "poi",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#d59563"
          }
        ]
      },
      {
        "featureType": "poi.business",
        "elementType": "labels.icon",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#263c3f"
          }
        ]
      },
      {
        "featureType": "poi.park",
        "elementType": "labels.icon",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "poi.park",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#6b9a76"
          }
        ]
      },
      {
        "featureType": "poi.school",
        "elementType": "labels.icon",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#38414e"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "geometry.stroke",
        "stylers": [
          {
            "color": "#212a37"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#9ca5b3"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#746855"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [
          {
            "color": "#1f2835"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#f3d19c"
          }
        ]
      },
      {
        "featureType": "transit",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#2f3948"
          }
        ]
      },
      {
        "featureType": "transit.station",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#d59563"
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#17263c"
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#515c6d"
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "labels.text.stroke",
        "stylers": [
          {
            "color": "#17263c"
          }
        ]
      }
    ]
  };

  // Show Info Window
  const onMarkerClick = React.useCallback(() => {
    setShowInfo(true);
  })
  // Hide Info Window
  const onInfoCloseClick = React.useCallback(() => {
    setShowInfo(false);
  })

  // return component
  return (
    isLoaded
        ? <GoogleMap
            mapContainerStyle={{
              width: '100%',
              height: '100%'
            }}
            options={options}
          >
            <Marker  
              position={center}
              icon={`/img/A - 48 x 48.png`}
              animation={google.maps.Animation.DROP}
              title={`TRIBALISM`}
              onClick={onMarkerClick}
            >
              {showInfo && 
                <InfoWindow
                  onCloseClick={onInfoCloseClick}
                >
                  <div className="info-window-content">
                    <h5>TRIBALISM PTY LTD</h5>
                    <p>
                      You found us - now lets work together! 😀
                    </p>
                  </div>
                </InfoWindow>
              }
            </Marker>
          </GoogleMap>
        :<></>
  );
}

export default TribalismGoogleMap;